import React, { useEffect, useState } from 'react'
import { useCustomSearchParams } from '../../hooks/useCustomSearchParams';
import Filters from './filters.js';
import Table from './table/index.js';
import Heading from '../../components/Heading';
import EnterNoticeResponse from './components/EnterNoticeResponse';
import DownloadAuditReport from '../Client/detail/components/Units/DownloadAuditReport';
import { downloadAuditReportFire } from '../../sevices/fireNoticeApi';
import { isAdmin, isSelfService } from '../../utils/helpers';

function FireNotice() {
  const [year, setYear] = useCustomSearchParams("year");
  const currentYear = new Date().getFullYear();
  const [building_id] = useCustomSearchParams("building");
  const [client] = useCustomSearchParams("client");
  const [isPastYear, setPastYear] = useState(false);
  const is_self_service = isSelfService();

  useEffect(() => {
    setPastYear(currentYear > year);
  }, []);

  useEffect(() => {
    setYear("year", year || currentYear);
  }, []);
  
  return (
    <div>
      <Heading title="Fire Notice">
        { isPastYear || ( isAdmin() || is_self_service && <EnterNoticeResponse />)}
        {(isAdmin() || is_self_service) && <DownloadAuditReport
          building={building_id}
          client={client}
          downloadAuditReportPdf={downloadAuditReportFire}
          reportId={"firePdfId"}
        />}
      </Heading>

      <div className="mt-4 ticket-page">
        <Filters building={building_id} client={client} />
        <Table />
      </div>
    </div>
  );
}

export default FireNotice